import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[commentDetailDirective]',
})
export class CommentDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}